import NsContent from 'components/common/ns-content/NsContent';

import { useCurrentProduct } from 'components/direct-sales/quote/hooks/useCurrentProduct';
import { NsCard } from 'components/common/ns-card/NsCard';
import { NsPrice } from 'components/common/ns-price/NsPrice';

import DirectDebitLogo from 'assets/images/direct-debit.svg';

export const testId = 'directDebitSummaryTestId';

export const DirectDebitSummary = () => {
  const product = useCurrentProduct();
  const { monthlyAmount = 0 } = product;
  return (
    <div data-testid={testId}>
      <NsContent>
        <img
          src={DirectDebitLogo}
          width="145.22"
          height="47"
          alt="Direct Debit Logo"
        />
        <NsCard
          type="section"
          heading={
            <>
              <NsPrice amount={monthlyAmount} /> / month
            </>
          }
        />
      </NsContent>
    </div>
  );
};
